module.exports = __webpack_public_path__ + "static/media/image7.af3fb2fa.jpg";